import { PROFILE_LOCAL_STORAGE_KEY } from 'modules/profile/constants/index.js'
import getItemLocalStorageUtil from 'modules/local-storage/get-item/index.js'

export default function getProfileDataFromLocalStorageProfileUtil () {
  let profileData
  try {
    const profileDataStr = getItemLocalStorageUtil(PROFILE_LOCAL_STORAGE_KEY.PROFILE_DATA)
    if (profileDataStr) {
      profileData = JSON.parse(profileDataStr)
    }
  } catch (error) {
  }
  profileData = profileData || {}
  return profileData
}
